import React from 'react';
import { responsiveFont, responsivePaddingHorizontal, responsivePaddingVertical, responsiveImageSize, HorizontalPadding } from '../../common/responsive.utils';
import useMediaQuery from '@mui/material/useMediaQuery';
import ZeroMoney_Web from '../../../assets/icon/sitter/mobile/zero_money.svg';
import Calendar_Web from '../../../assets/icon/sitter/mobile/calendar.svg';
import IconBook_Web from '../../../assets/icon/sitter/mobile/icon_book.svg';
import ZeroMoney_Mobile from '../../../assets/icon/sitter/mobile/zero_money.svg';
import Calendar_Mobile from '../../../assets/icon/sitter/mobile/calendar.svg';
import IconBook_Mobile from '../../../assets/icon/sitter/mobile/icon_book.svg';

const Content02BrowserComponent = ({...props}) : React.ReactElement => {
    // 데스크탑-웹: 768px ~ 1920px
    const isWeb = useMediaQuery('(min-width:768px)', {noSsr : true});
    const styles = getStyles();

    return (
        <>
            {isWeb ? (
                <>
                    <div style={styles.screen_Web}>
                        <span style={styles.titleTxt_Web}>
                            왜 우주펫에서 해야하나요?
                        </span>
                        <div style={styles.screenRow_Web}>
                            <div style={{ height: 40 }} />

                            <div style={styles.screenColumn_Web}>

                                <img src={ZeroMoney_Web} style={styles.icon_Web} alt="수수료없음" />

                                <span style={styles.subTitleTxt_Web}>
                                    수수료 0원
                                </span>

                                <span style={styles.contentTxt_Web}>
                                    보호자님에게 받은 돌봄 비용,<br />
                                    그대로 가져가세요
                                </span>
                            </div>

                            <div style={{ height: 56 }} />
                            <div style={styles.screenColumn_Web}>
                                <img src={Calendar_Web} style={styles.icon_Web} alt="수수료없음" />

                                <span style={styles.subTitleTxt_Web}>
                                    자유로운 스케줄 관리
                                </span>

                                <span style={styles.contentTxt_Web}>
                                    내가 원하는 날에만<br />
                                    돌봄을 할 수 있어요
                                </span>
                            </div>
                            <div style={{ height: 56 }} />

                            <div style={styles.screenColumn_Web}>
                                <img src={IconBook_Web} style={styles.icon_Web} alt="수수료없음" />

                                <span style={styles.subTitleTxt_Web}>
                                    우주펫 시터 입문 교육 제공
                                </span>

                                <span style={styles.contentTxt_Web}>
                                    반려동물과 펫시팅에 대한<br />
                                    기본 지식을 갖출 수 있어요
                                </span>
                            </div>
                        </div>
                    </div>
                </>
            ) : (
                <>
                    <div style={styles.screen_Mobile}>
                        <span style={styles.titleTxt_Mobile}>
                            왜 우주펫에서 해야하나요?
                        </span>

                        <div style={{ height: "12.5000vw" }} />

                            <img src={ZeroMoney_Mobile} style={styles.icon_Mobile} alt="수수료없음" />

                        <span style={styles.subTitleTxt_Mobile}>
                            수수료 0원
                        </span>

                        <span style={styles.contentTxt_Mobile}>
                            보호자님에게 받은 돌봄 비용,<br />
                            그대로 가져가세요
                        </span>

                        <div style={{ height: "13.5000vw" }} />

                            <img src={Calendar_Mobile} style={styles.icon_Mobile} alt="수수료없음" />

                        <span style={styles.subTitleTxt_Mobile}>
                            자유로운 스케줄 관리
                        </span>

                        <span style={styles.contentTxt_Mobile}>
                            내가 원하는 날에만<br />
                            돌봄을 할 수 있어요
                        </span>

                        <div style={{ height: 56 }} />

                            <img src={IconBook_Mobile   } style={styles.icon_Mobile} alt="수수료없음" />

                        <span style={styles.subTitleTxt_Mobile}>
                            우주펫 시터 입문 교육 제공
                        </span>

                        <span style={styles.contentTxt_Mobile}>
                            반려동물과 펫시팅에 대한<br />
                            기본 지식을 갖출 수 있어요
                        </span>
                    </div>
                </>
            )}
        </>
    );
}

const getStyles = (): Record<string, React.CSSProperties> => ({
    screen_Web: { backgroundColor: "white", display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", paddingTop: responsivePaddingVertical(50, 90), paddingBottom: responsivePaddingVertical(59, 70), paddingLeft: responsivePaddingHorizontal(24, 88), paddingRight: responsivePaddingHorizontal(24, 88) },
    screenRow_Web: { display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "center", width: "100%" },
    screenColumn_Web: { backgroundColor: "white", display: "flex", flexDirection: "column", alignItems: "center", paddingTop: 50, paddingBottom: 59, paddingRight: 60 },
    titleTxt_Web: { fontSize: responsiveFont(22, 40), fontWeight: 700, letterSpacing: -0.3, alignSelf: "flex-start", paddingLeft: HorizontalPadding(24, 50), lineHeight: "140%" },
    subTitleTxt_Web: { fontSize: responsiveFont(18, 34), fontWeight: 700, color: "#9F6BFF", letterSpacing: -0.3, marginTop: 16, marginBottom: 6, lineHeight: "120%" },
    contentTxt_Web: { fontSize: responsiveFont(14, 28), fontWeight: 400, color: "#62686D", letterSpacing: -0.3, textAlign: "center", lineHeight: "140%" },
    icon_Web: { width: responsiveImageSize(58, 116), height: responsiveImageSize(58, 116) },
    
    screen_Mobile: { width: "100%", minWidth: "320px", backgroundColor: "white", display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", paddingTop: responsivePaddingVertical(50, 90), paddingBottom: responsivePaddingVertical(59, 70)},
    titleTxt_Mobile: { fontSize: responsiveFont(22, 40), fontWeight: 700, letterSpacing: -0.3, alignSelf: "flex-start", lineHeight: "140%", paddingLeft:HorizontalPadding(24, 88)},
    subTitleTxt_Mobile: { fontSize: responsiveFont(18, 34), fontWeight: 700, color: "#9F6BFF", letterSpacing: -0.3, marginTop: "3.7500vw", marginBottom: "1.8750vw", lineHeight: "120%" },
    contentTxt_Mobile: { fontSize: responsiveFont(14, 28), fontWeight: 400, color: "#62686D", letterSpacing: -0.3, textAlign: "center", lineHeight: "140%" },
    icon_Mobile: { width: responsiveImageSize(58, 116), height: responsiveImageSize(58, 116) }
});

export default Content02BrowserComponent;